/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HousingSiteDetail } from '../models/HousingSiteDetail';
import type { HousingSiteDetailDto } from '../models/HousingSiteDetailDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HousingSiteDetailsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all details in the DB.
     * @param sysOrgGuid
     * @returns HousingSiteDetailDto OK
     * @throws ApiError
     */
    public getAllDetails(
        sysOrgGuid: string,
    ): CancelablePromise<Array<HousingSiteDetailDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingSiteDetails/{sysOrgGuid}/GetAllDetails',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
        });
    }
    /**
     * Update a detail by its guid.
     * @param detailGuid The guid of the detail.
     * @param requestBody The updated detail.
     * @returns HousingSiteDetailDto OK
     * @throws ApiError
     */
    public updateDetail(
        detailGuid: string,
        requestBody?: HousingSiteDetail,
    ): CancelablePromise<HousingSiteDetailDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/housing/HousingSiteDetails/{detailGuid}',
            path: {
                'detailGuid': detailGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new Detail.
     * @param requestBody The new detail.
     * @returns HousingSiteDetailDto OK
     * @throws ApiError
     */
    public createDetail(
        requestBody?: HousingSiteDetail,
    ): CancelablePromise<HousingSiteDetailDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingSiteDetails',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
